module.exports = __webpack_public_path__ + "static/media/arthur.6062ff30.jpg";